import { render, staticRenderFns } from "./member_agreement.vue?vue&type=template&id=5bf6d5cf&scoped=true"
import script from "./member_agreement.vue?vue&type=script&lang=js"
export * from "./member_agreement.vue?vue&type=script&lang=js"
import style0 from "./member_agreement.vue?vue&type=style&index=0&id=5bf6d5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6d5cf",
  null
  
)

export default component.exports